<template>
    <ButtonPrimary :loading="status === Status.LOADING" :onClick="handleSignUp">
        {{ t({ key: 'sembonus.yes_sign_me_up_for_sembonus' }) }}
    </ButtonPrimary>
    <span v-if="status === Status.ERROR">
        {{ t({ key: 'shared.something_went_wrong' }) }}
    </span>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { computed, defineComponent, ref } from 'vue';
    import { endpoints } from '@/api/endpoints';
    import { SemboUser } from '@/api/Members/members.interfaces';
    import { getErrorMessage, handleCustomError } from '@/config/errorHandling';
    import { ModalType } from '@/store/general/types';
    import { logStatsigCheckoutSembonusInteraction } from '@/tracking/statsig/checkout.functions';
    import ButtonPrimary from '@ui/components/Button/ButtonPrimary.vue';

    export enum Status {
        INITIAL = 'INITIAL',
        LOADING = 'LOADING',
        ERROR = 'ERROR',
        SUCCESS = 'SUCCESS',
    }

    export default defineComponent({
        name: 'SignUp',
        methods: { t },
        components: { ButtonPrimary },
        setup() {
            const store = useStore();

            const status = ref<Status>(Status.INITIAL);

            const user = computed<SemboUser>(() => store.getters['auth/getUser']);

            async function handleSignUp() {
                try {
                    setInitial();

                    const username = user.value?.member?.userName;
                    if (!username) {
                        throw new Error('No username found');
                    }

                    await endpoints.members.OptInMember(username);
                    setSuccess();
                } catch (error) {
                    setError(error);
                }
            }

            function setInitial() {
                status.value = Status.INITIAL;
            }

            function setSuccess() {
                status.value = Status.SUCCESS;
                store.dispatch('general/setModal', { type: ModalType.WelcomeSembonus });
                store.dispatch('auth/setUserMemberOptIn');
                logStatsigCheckoutSembonusInteraction('OptIn');
            }

            function setError(error: any) {
                status.value = Status.ERROR;
                handleCustomError(`[Sembonus] SignUp: ${getErrorMessage(error)}`);
            }

            return { handleSignUp, status, Status };
        },
    });
</script>
